import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.tsconfig = languageMap.typoscript = bracketIndenting()
